import { render, staticRenderFns } from "./kirimangratis.vue?vue&type=template&id=48d14a26"
import script from "./kirimangratis.vue?vue&type=script&lang=js"
export * from "./kirimangratis.vue?vue&type=script&lang=js"
import style0 from "./kirimangratis.vue?vue&type=style&index=0&id=48d14a26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports